import { render, staticRenderFns } from "./tenant-list.vue?vue&type=template&id=364a1614&scoped=true"
import script from "./tenant-list.vue?vue&type=script&lang=js"
export * from "./tenant-list.vue?vue&type=script&lang=js"
import style0 from "./tenant-list.vue?vue&type=style&index=0&id=364a1614&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364a1614",
  null
  
)

export default component.exports